import styled from '@emotion/styled';
import { LoaderDiv } from '../components/styledComponent/Boxes.style';
import { TabletWidth } from '../global.style';

export const PaymentSummaryLoaderDiv = styled(LoaderDiv)`
  flex-direction: column;
`;

export const PaymentSummaryLoaderText = styled.p`
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;

  margin-bottom: 24px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`;
